var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19667 4.70401C3.19667 3.87134 3.87134 3.19667 4.70401 3.19601H5.39001C5.78801 3.19601 6.16934 3.03801 6.45201 2.75801L6.93134 2.27801C7.51867 1.68734 8.47334 1.68467 9.06401 2.27201L9.06467 2.27267L9.07067 2.27801L9.55067 2.75801C9.83334 3.03867 10.2147 3.19601 10.6127 3.19601H11.298C12.1307 3.19601 12.806 3.87067 12.806 4.70401V5.38867C12.806 5.78667 12.9633 6.16867 13.244 6.45134L13.724 6.93134C14.3147 7.51867 14.318 8.47334 13.7307 9.06401L13.73 9.06467L13.724 9.07067L13.244 9.55067C12.9633 9.83267 12.806 10.214 12.806 10.612V11.298C12.806 12.1307 12.1313 12.8053 11.2987 12.8053H10.6113C10.2133 12.8053 9.83134 12.9633 9.54934 13.244L9.06934 13.7233C8.48267 14.314 7.52867 14.3173 6.93801 13.7313C6.93734 13.7307 6.93667 13.73 6.93601 13.7293L6.93001 13.7233L6.45067 13.244C6.16867 12.9633 5.78667 12.806 5.38867 12.8053H4.70401C3.87134 12.8053 3.19667 12.1307 3.19667 11.298V10.6107C3.19667 10.2127 3.03867 9.83134 2.75801 9.54934L2.27867 9.06934C1.68801 8.48267 1.68467 7.52867 2.27134 6.93801C2.27134 6.93734 2.27201 6.93667 2.27267 6.93601L2.27867 6.93001L2.75801 6.45001C3.03867 6.16734 3.19667 5.78601 3.19667 5.38734V4.70401Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.00008L7.33333 9.33341L10 6.66675",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.2a074bf9137efe1c0e65904f01cba3d3.svg";
export { ForwardRef as ReactComponent };